<div class="card card-details" id="basic-info">
  <div class="card-content">
    <div class="row">
      <div class="col-sm-12 col-md-4 col-lg-2">
        <div class="card-details-image">
          <img *ngIf="restaurantProfile?.icon" [src]="restaurantProfile?.icon" alt="">
        </div>
      </div>
      <div class="col-7 col-md-4 col-lg-6">
        <div class="card-details-info mb-4">
          <span class="badge badge-success font-14 pl-3" *ngIf="restaurantProfile?.isOpenNow">
            <b>&bull;</b><span>{{'restaurant.Open Now' | translate}}</span></span>
            <span class="badge badge-danger font-14 pl-3" *ngIf="!restaurantProfile?.isOpenNow">
              <b>&bull;</b><span>{{'restaurant.Closed Now' | translate}}</span></span>
          <p class="font-20 ml-1 mt-2 fontSemiBold top-title" *ngIf="lang == 'en'">
            {{restaurantProfile?.title_EN}}
            <span *ngIf="restaurantProfile?.shortName" class="font-16 fontRegular ml-3">({{restaurantProfile?.shortName}})</span>
          </p>
          <p class="font-20 ml-1 mt-2 fontSemiBold top-title" *ngIf="lang == 'ar'">
            {{restaurantProfile?.title_AR}}
            <span *ngIf="restaurantProfile?.shortName" class="font-16 fontRegular ml-3">({{restaurantProfile?.shortName}})</span>
          </p>
          <div class="ml-1">
            <span class="font-14 card-details-sub-title fontRegular"
              *ngFor="let cusine of restaurantProfile?.restaurantCuisine; let last = last">
              {{cusine.cuisine.name}}<span *ngIf="!last">,
              </span>
            </span>
          </div>
          <p class="font-16 ml-1 fontRegular date-created">{{'forms.VAT number' | translate}}: <span
              class="ml-2 font-16 fontMedium">{{restaurantProfile?.vatNumber}}</span>
          </p>
          <p class="font-16 ml-1 fontRegular date-created">{{'content.Created on' | translate}}: <span
              class="ml-2 font-16 fontMedium">{{restaurantProfile?.created | date: 'dd MMM, y'}}</span>
          </p>
        </div>

      </div>
      <div class="col-5 col-md-4 text-right">
        <div class="button-actions mb-4">
          <button type="button" class="btn btn-with-icon mr-3" (click)="DeleteRestaurant()"
            *ngIf="restaurantProfile?.canDelete">
            <mat-icon>delete</mat-icon>
          </button>

          <a class="btn-light mt-1" mat-stroked-button *ngIf="restaurantProfile?.canEdit"
            (click)="openForm()">{{'general.Edit' | translate}}</a>
        </div>


        <div class="qr-code mb-4 text-right" id="qr-code">
          <div class="img-card ml-auto">
            <div id="qr-code-id">
              <img [src]="'data:image/png;base64,' + restaurantProfile?.menuQRCode">
            </div>
            <button type="button" mat-icon-button (click)="print()"><img src="./assets/images/icons/checkout/print-receipt-ic.svg" alt=""></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="d-none">
  <div id="qrCode-print">
    <table class="print-container">
      <tr>
        <td class="text-left">
          <img class="rest-logo" [src]="restaurantProfile?.icon" alt="">
          <h4>{{restaurantProfile?.name}}</h4>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          <h3>{{'menu.Scan for Menu' | translate}}</h3>
          <img class="rest-qrcode" [src]="'data:image/png;base64,' + restaurantProfile?.menuQRCode">
        </td>
      </tr>

      <tr>
        <td colspan="2">
          <h6>{{'menu.Powered by' | translate}}</h6>
          <img class="system-logo" src="./assets/images/logos/logo.svg" alt="">
        </td>
      </tr>
    </table>
  </div>
</div>
